import { isDoubleDpc } from "../utils/config";
import useCategory from "../utils/useCategory";
import Product from "./Product";

const supported = {
    'dentaire': 2,
    'kine': 1,
    'sante-mentale': 2,
    'pharma': 2,
    'medecine': 2,
    'infirmiere': 1
}

/**
 * 
 * À afficher entre le 14/10 et le 31/12 2024
 */
export default function NewDpcFc({ product }){

    const category = useCategory()

    return product &&

        <Product product={product}>

            <div className="apply-option-title">
                <span>DPC</span>
            </div>

            <div className="apply-option-row">
                <span><b>Formation Continue</b></span>
            </div>

            <div className="apply-option-divider"></div>

            <div className="apply-option-row">
                <span>100% pris en charge</span>
            </div>

            <div className="apply-option-divider"></div>

            <div className="apply-option-row">
                <span>Sans avance de frais</span>
            </div>

            <div className="apply-option-divider"></div>

            <div className="apply-option-row">
                <span>
                    Indemnité allant jusqu'à 
                </span>
                <span className="apply-badge-grey" style={{backgroundColor: category?.color, color: 'white'}}>
                    {product.price}€
                </span>
            </div>

            <div className="apply-option-divider"></div>

            <div className="apply-option-row">
                {isDoubleDpc ? 
                    <span>
                        Jusqu'à <b>{supported[category?.id] || 1}</b> formation(s) DPC prises en charge par an
                    </span>
                    :
                    <span>
                        Utilise vos crédits 2026.
                    </span>
                }
            </div>

            <div className="apply-option-divider"></div>

            <div className="apply-option-row">
                <span>Répond partiellement à l'obligation triennale</span>
            </div>

            <div className="apply-option-divider"></div>

            <div className="apply-option-row">
                <span>Inscription dès 1h de crédit restant</span>
            </div>

            <div className="apply-option-divider"></div>

            <div className="apply-option-row">
                <span>Session d'une durée maximale de 3 mois au cours de laquelle vous devez achever votre formation</span>
            </div>

            <div className="apply-option-divider"></div>

            <div className="apply-option-row">
                <span>Uniquement FC</span>
            </div>
            
        </Product>
}